/* eslint-disable radix */
/* eslint-disable no-unused-vars */
import { getServerTimestamp } from '../../Services/@sgorg/game-backend-client-mock';
import { Window } from '../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import ShopUtils, { SHOP_EVENT_KEYS } from './Shop/Shop_Utils';
import SpecialDeal from './Shop/Shop_SpecialDeal';
import { Shop_CoinBar } from './Shop/Shop_CoinBar';

const FRAME_AREA_RECT = new Phaser.Rectangle(-280, -370, 560, 900);

/**
 * class for store special offer popup
 */
export class Window_popupOffer extends Window {
  /**
   * constructor
   * @param {Object} parent
   */
  constructor(parent) {
    super(parent);

    this._runningEvent = undefined;
    this._offerGroup = new Phaser.Group(window.game, null);
    this._currentDeal = null;

    this.waitingIcon = new G.WaitingIcon(0, 0, 'waiting_icon'); // Loading...
    this.addChild(this.waitingIcon);

    this.onFinishedEnter.addOnce(this.getCatalog.bind(this));
  }

  /**
   * destruction method
   */
  destroy() {
    this.removeWaitingIcon();
    super.destroy();
  }

  /**
   * Get catalog and other required async flags
   */
  async getCatalog() {
    if (await OMT.feature.getEventPostcardFeature()) {
      const IAPCount = G.saveState.getIAPCount();
      this._runningEvent = {
        key: SHOP_EVENT_KEYS.POSTCARD,
        packageId: (IAPCount === 0 ? G.OMTsettings.postcardEvent.shop.firstTimeBuyerKey : '') + G.OMTsettings.postcardEvent.shop.popupKey + G.OMTsettings.postcardEvent.eventId,
      };
    }
    const fetchedCatalog = await OMT.payments.getCatalogAsync();
    if (fetchedCatalog) {
      const filteredCatalog = ShopUtils.filterPopupOffers(fetchedCatalog, this._runningEvent);
      const pickedDealIndex = Math.floor(Math.random() * filteredCatalog.length);
      this._currentDeal = filteredCatalog[pickedDealIndex];
      if (this._runningEvent) {
        this.drawEventDeal();
      } else {
        this.drawDeal();
      }
    } else {
      this.closeWindow();
    }
    this.removeWaitingIcon();
  }

  /**
   * remove the waiting / loading icon
   */
  removeWaitingIcon() {
    if (this.waitingIcon) {
      const tw = game.add.tween(this.waitingIcon)
        .to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.InOut, true);
      tw.onComplete.addOnce(() => {
        if (this.waitingIcon) {
          if (this.waitingIcon.parent) {
            this.waitingIcon.parent.removeChild(this.waitingIcon);
          }
          this.waitingIcon.destroy();
        }
        this.waitingIcon = null;
      });
    }
  }

  /**
   * daw the special offer deal
   */
  drawDeal() {
    this.bg = this.addGeneric9SliceBackground(450, 750);
    const bgHead = G.makeImage(0, FRAME_AREA_RECT.y + 40, 'store_bg', 0.5, this);

    const headText = new G.Text(
      bgHead.x,
      bgHead.y + G.OMTsettings.elements.Window_popupOffer.headerOffset,
      OMT.language.getText('Special Deal'),
      G.OMTsettings.elements.Window_shop2.headerFontStyle ? G.OMTsettings.elements.Window_shop2.headerFontStyle : G.OMTsettings.global.window.title.textStyle,
      0.5,
      bgHead.width * (7 / 10),
      bgHead.height * (7 / 10),
      true,
      'center',
    );
    this.addChild(headText);

    const rewardBg = G.makeImage(0, -100, 'reward_BG', 0.5, this._offerGroup);
    rewardBg.scale.set(0.8);
    G.makeImage(0, -100, 'coin_3', 0.5, this._offerGroup);
    const coinBg = G.makeImage(0, 80, 'top-panel-coinsBg', 0.5, this._offerGroup);
    coinBg.scale.set(1.2);

    this._makeButtons({ x: 0, y: 180 }, { x: 0, y: 280 });

    const splitID = this._currentDeal.productID.split('_');
    const amountCoins = splitID[splitID.length - 1].replace('k', '000');
    const coinText = new G.Text(
      20,
      3,
      amountCoins,
      G.OMTsettings.global.window.title.textStyle,
      0.5,
      coinBg.width * (6 / 10),
      coinBg.height * (7 / 10),
      true,
      'center',
    );
    coinBg.addChild(coinText);

    this.add(this._offerGroup);
    this.addCloseButton(220, -355);
  }

  /**
   * draw special event deals, this uses the same SpecialDeal class as the coinShop
   */
  async drawEventDeal() {
    const assetList = {};
    if (this._runningEvent.key === SHOP_EVENT_KEYS.POSTCARD) {
      assetList.background = {
        sheet: 'eventPostcard',
        asset: 'popup_eventPostcard',
        slice: G.OMTsettings.postcardEvent.cardData.border.slices,
        offset: { x: G.OMTsettings.postcardEvent.cardData.border.offset.x || 0, y: G.OMTsettings.postcardEvent.cardData.border.offset.y || 0 },
        extra: G.OMTsettings.postcardEvent.cardData.border.extra,
        dimensions: G.OMTsettings.postcardEvent.shop.popupDimensions,
        title: G.OMTsettings.postcardEvent.shop.specialPopupOffer,
      };
      if (G.featureUnlock.eventPostcard.range) {
        assetList.timer = {
          start: G.featureUnlock.eventPostcard.range.start,
          end: G.featureUnlock.eventPostcard.range.end,
        };
      }
    }

    this.bg = new PhaserNineSlice.NineSlice(assetList.background.offset.x, assetList.background.offset.y, assetList.background.sheet,
      assetList.background.asset, assetList.background.dimensions.width, assetList.background.dimensions.height, assetList.background.slice);
    this.bg.anchor.set(0.5);
    this.addChild(this.bg);
    if (assetList.background.extra) {
      const centerPoint = {
        x: assetList.background.offset.x - (this.bg.width / 2),
        y: assetList.background.offset.y - (this.bg.height / 2),
      };
      for (let i = 0; i < assetList.background.extra.length; i++) {
        const extraData = assetList.background.extra[i];
        const extraDetail = G.makeImage(0, 0, extraData.asset, 0.5, this);
        extraDetail.x = centerPoint.x + (this.bg.width * (extraData.align[0] || 0));
        extraDetail.y = centerPoint.y + (this.bg.height * (extraData.align[1] || 0));
      }
    }

    const title = new G.Text(Math.round(assetList.background.offset.x), 0, OMT.language.getText(assetList.background.title), { style: 'eventPostcard-title', fontSize: 64 },
      0.5, this.bg.width - assetList.background.slice.left - assetList.background.slice.right, assetList.background.slice.top * 0.9, true, 'center');
    title.y = Math.round((this.bg.y - (this.bg.height / 2)) + (assetList.background.slice.top / 2));
    this._offerGroup.addChild(title);

    this._special = new SpecialDeal(window.game, { // Special fancy deals!!
      catalog: this._currentDeal,
      event: this._runningEvent,
    });
    this._special.button.destroy();
    this._special.strikePrice.destroy();
    this._special.timer.destroy();
    this._special.chest.y = this._special.calculatedHeight / 16;
    this._offerGroup.addChild(this._special);

    this._makeButtons({ x: 0, y: 130 }, { x: 0, y: 230 });

    if (assetList.timer) {
      this._timer = await this._makeTimerText('eventPostcard-caption', assetList.timer);
      this._timer.y = Math.round(this.bg.y + assetList.background.slice.top + (this._timer.height - this.bg.height) / 2);
      this._special.y = Math.round(this._timer.y + (this._timer.height + this._special.height) / 2);
    } else {
      this._special.y = Math.round(this.bg.y + assetList.background.slice.top - (this.bg.height - this._special.height) / 2);
    }
    this.add(this._offerGroup);

    this.addCloseButton(220, -325);
  }

  /**
   * make buy, cancel buttons
   * @param {Object} buyPos
   * @param {Object} cancelPos
   */
  _makeButtons(buyPos, cancelPos) {
    const onClick = () => {
      this.purchaseItem(this._currentDeal);
    };
    const buyButton = new OMT_UI_SquareButton(buyPos.x, buyPos.y, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: this._currentDeal.price,
        textStyle: { style: 'font-white', fontSize: 40 },
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
        },
      },
    });
    this._offerGroup.add(buyButton);
    this._buyButton = buyButton;

    const onCancelClick = () => {
      this.closeWindow();
    };
    const cancelButton = new OMT_UI_SquareButton(cancelPos.x, cancelPos.y, {
      button: {
        tint: BUTTONCOLOURS.red,
        dimensions: {
          width: 166,
          height: 86,
        },
        extraDetail: false,
      },
      text: {
        string: OMT.language.getText('No, thanks'),
        textStyle: { style: 'font-white', fontSize: 40 },
      },
      options: {
        clickFunction: {
          onClick: onCancelClick.bind(this),
        },
      },
    });
    this._offerGroup.add(cancelButton);
  }

  /**
   * make timer text
   * @param {string} textS
   * @param {Object} timeData
   */
  async _makeTimerText(textS, timeData) {
    const curTime = await getServerTimestamp();
    const endTime = timeData.end;
    const timer = new G.TextTimer(0, 0, null, textS, 0.5, this.bg.width * 0.8, 'hms', OMT.language.getText('Ends in %TIME%'));
    timer.setSecLeft((endTime - curTime) / 1000);
    timer.active = true;
    this._offerGroup.addChild(timer);
    return timer;
  }


  /**
  * tries to purchase an item
  * @param {Object} item to buy
  */
  purchaseItem(item) {
    OMT.payments.buyAndConsumeProduct(item, (product, purchase, success) => {
      if (success) ShopUtils.processPurchase(product, purchase, this._buyButton);
      this.closeWindow();
    });
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.popupOffer = Window_popupOffer;
